import store from '@/state/store'

export default [{
        path: '/',
        name: 'default',
        meta: { authRequired: false },
        component: () =>
            import ('./views/dashboards/default'),
    },
    {
        path: '/login',
        name: 'login',
        component: () =>
            import ('./views/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'Register',
        component: () =>
            import ('./views/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot password',
        component: () =>
            import ('./views/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {

                store.dispatch('auth/logout')

                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                        (route) => route.push('/login')
                    )
                    // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'default' } : {...routeFrom })
            },
        },
    },

    {
        path: '/update_password',
        name: 'Update Password',
        component: () =>
            import ('./views/account/update_password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },

    {
        path: '/businesslist',
        name: 'Business List',
        component: () =>
            import ('./views/account/businesslist'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/token']) {
                    // Redirect to the home page instead
                    next({ name: 'default' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/add_item',
        name: 'Add Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/add_product')
    },
    {
        path: '/units/view',
        name: 'Product Units',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/units')
    },
    {
        path: '/products/search_products',
        name: 'Search Product',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/search_products')
    },
    {
        path: '/categories/view',
        name: 'Product Categories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/categories')
    },
    {
        path: '/business/products',
        name: 'Business Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/business')
    },
    {
        path: '/view_items',
        name: 'Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/products')
    },
    {
        path: '/products/units',
        name: 'ProductUnits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/products/product_units')
    },
    {
        path: '/suppliers/view',
        name: 'Suppliers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/suppliers')
    },
    {
        path: '/suppliers/supplierprofile/:id',
        name: 'Suppliers Profile',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierprofile')
    },
    {
        path: '/supplier/deposits',
        name: 'Supplier Deposits',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/supplier_deposit')
    },
    {
        path: '/supplier_balances',
        name: 'SupplierBalances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalances')
    },
    {
        path: '/supplierbalance_details/:id',
        name: 'SupplierBalance_details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/supplierbalance_details')
    },
    {
        path: '/supplier/descriptive_balancedetails/:id',
        name: 'Descriptive Supplier Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/descriptive_balancedetails')
    },
    {
        path: '/supplier/print_descriptive_balancedetails/:id',
        name: 'Print Descriptive Supplier Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/descriptive_balance_detailsprint')
    },
    {
        path: '/supplier/print_balance_details/:id/:datefrom/:dateto',
        name: 'Print Supplier Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/accounts/balance_detailsprint')
    },
    {
        path: '/view_inventory_levels',
        name: 'Inventory Level',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stock')
    },
    {
        path: '/stock/allstock',
        name: 'All Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/allstock')
    },
    {
        path: '/stock/stockvalue',
        name: 'Stock Value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/stockvalue')
    },
    {
        path: '/stock/outof_stock',
        name: 'Out of Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/outof_stock')
    },
    {
        path: '/stock/runningout_ofstock',
        name: 'Running out of stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/runningout_ofstock')
    },
    {
        path: '/stock/in_stock',
        name: 'In Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/in_stock')
    },
    {
        path: '/purchase/new',
        name: 'New Purchase',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/new_purchase')
    },
    {
        path: '/spoilt_inventory',
        name: 'Spoilt Inventory',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/spoilt_stock')
    },
    {
        path: '/stock/pendingspoilt',
        name: 'Pending SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/pending_spoiltstock')
    },
    {
        path: '/stock/rejectedspoilt',
        name: 'Rejected SpoiltStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/rejected_spoiltstock')
    },
    {
        path: '/stock/batches',
        name: 'Batches',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/batches')
    },
    {
        path: '/stock/shortExpiries',
        name: 'Short Expiries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/short_expiries')
    },
    {
        path: '/stock/expired',
        name: 'ExpiredStock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/expired')
    },
    {
        path: '/stock_taking',
        name: 'Stock Taking',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile')
    },
    {
        path: '/stock/reconcileall',
        name: 'Reconcile all Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcileall')
    },
    {
        path: '/stock_taking_report',
        name: 'Stock Taking Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconciliation_report')
    },
    {
        path: '/reconciliation/details/:id',
        name: 'Reconciliation Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/reconcile_details')
    },
    {
        path: '/shop/purchases',
        name: 'Shop Purchase Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/shop_purchase_report')
    },
    {
        path: '/purchase_details/:id',
        name: 'Purchase Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/purchase_details')
    },
    {
        path: '/supplierdeposit_details/:id',
        name: 'Supplier Deposit Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/supplierdeposit_details')
    },

    {
        path: '/advanced_reports/sellingprice_changes',
        name: 'Selling Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sellingprice_changes')
    },

    {
        path: '/advanced_reports/shopprice_changes',
        name: 'Shop Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shopprice_changes')
    },

    {
        path: '/purchases/creditors',
        name: 'Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/creditors')
    },

    {
        path: '/purchases/imported_creditors',
        name: 'Imported Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/imported_creditors')
    },

    {
        path: '/creditor_details/:id',
        name: 'Imported Creditor Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/creditor_details')
    },

    //  store
    {
        path: '/store/add',
        name: 'Add To Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/new_purchase')
    },
    {
        path: '/store/view',
        name: 'Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/stock')
    },
    {
        path: '/store/reconcile',
        name: 'Reconcile Store',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/reconcile')
    },
    {
        path: '/store/allstock',
        name: 'All Store Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/allstock')
    },
    {
        path: '/store/purchases',
        name: 'Store Purchases',
        meta: { authRequired: true },
        component: () =>
            import ('./views/store/store_purchases')
    },

    {
        path: '/advanced_reports/storeprice_changes',
        name: 'Store Price Changes Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/storeprice_changes')
    },
    {
        path: '/users/groups',
        name: 'Buy/sell',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/roles')
    },
    {
        path: '/users',
        name: 'Users',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/users')
    },
    {
        path: '/record_order',
        name: 'Record Sale',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/record_order')
    },
    {
        path: '/sales/confirm_order',
        name: 'Confirm Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/confirm_order')
    },
    {
        path: '/sales/readyorders',
        name: 'Ready Order',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/readyorders')
    },
    {
        path: '/sales',
        name: 'View Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/sales_report')
    },
    {
        path: '/sale_details/:id',
        name: 'View Sales Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/sale_details')
    },
    {
        path: '/sales/discounts',
        name: 'View Sale Discounts',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/discounts_allowed')
    },
    {
        path: '/payments',
        name: 'View Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/payments')
    },
    {
        path: '/purchase_payments',
        name: 'View Purchae Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/purchase_payments')
    },
    {
        path: '/sales/debtors',
        name: 'Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/debtors')
    },
    {
        path: '/sales/imported_debtors',
        name: 'Imported Debtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/imported_debtors')
    },
    {
        path: '/debtor_details/:id',
        name: 'Imported Debtors Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/debtor_details')
    },
    {
        path: '/sales/held',
        name: 'Held Sales',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/held_sales')
    },
    {
        path: '/hold/print/:id',
        name: 'Invoice',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/invoice')
    },
    {
        path: '/reports/untaken_orders',
        name: 'Un taken orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/untaken_orders')
    },
    {
        path: '/reports/dispatched_orders',
        name: 'Dispatched Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/dispatch_report')
    },
    {
        path: '/advanced_reports/payments',
        name: 'Customer Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/payments_report')
    },

    {
        path: '/advanced_reports/credit_payments',
        name: 'Credit Payments',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/credit_payments')
    },

    {
        path: '/custom_sms',
        name: 'Custom SMS',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/message_center')
    },
    {
        path: '/buy_sms',
        name: 'Buy SMS',
        meta: { authRequired: true },
        component: () =>
            import ('./views/messages/buysms')
    },
    {
        path: '/lpo',
        name: 'Purchase Orders',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo')
    },
    {
        path: '/lpo/new',
        name: 'New LPO',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/new_lpo')
    },
    {
        path: '/lpo/details/:id',
        name: 'LPO Details',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/lpo_details')
    },
    {
        path: '/lpo/print/:id',
        name: 'Print LPO',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/lpo_print')
    },


    // Quotations and Invoices
    {
        path: '/quotations/new',
        name: 'New Quotation',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/quotations/new_quotation')
    },
    {
        path: '/quotations/view',
        name: 'View Quotation',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/quotations/quotations')
    },
    {
        path: '/quotation/details/:id',
        name: 'Quotation Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/quotations/quotation_details')
    },
    {
        path: '/printquotation/:id',
        name: 'Print Quotation',
        meta: { authRequired: true },
        component: () =>
            import ('./views/quotations/quotation_print')
    },
    {
        path: '/invoices',
        name: 'View Invoice',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/invoices/invoices')
    },
    {
        path: '/invoice_details/:id',
        name: 'Print Invoice',
        meta: { authRequired: true },
        component: () =>
            import ('./views/invoices/invoice_details')
    },

    // Stock Transfers
    {
        path: '/stock/transfer',
        name: 'Transfer Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfer_stock')
    },
    {
        path: '/stock/transfer/direct',
        name: 'Direct Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/direct_stock_transfer')
    },
    {
        path: '/stock/transfers',
        name: 'Stock Transfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/transfers')
    },
    {
        path: '/stock/movement/:id',
        name: 'Stock Movement',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/stock/movements')
    },
    {
        path: '/user_logs',
        name: 'User Logs',
        meta: { authRequired: true },
        component: () =>
            import ('./views/reports/audits')
    },
    {
        path: '/ui/images',
        name: 'Images',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/images')
    },
    {
        path: '/ui/modals',
        name: 'Modals',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/modals')
    },
    {
        path: '/ui/drawer',
        name: 'Drawer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/drawer')
    },
    {
        path: '/ui/rangeslider',
        name: 'Rangeslider',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/rangeslider')
    },
    {
        path: '/ui/progressbars',
        name: 'Progressbars',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/progressbars')
    },
    {
        path: '/ui/sweet-alert',
        name: 'Sweet-alert',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/sweet-alert')
    },
    {
        path: '/ui/tabs-accordions',
        name: 'Tabs-accordions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/tabs-accordions')
    },
    {
        path: '/ui/typography',
        name: 'Typography',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/typography')
    },
    {
        path: '/ui/video',
        name: 'Video',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/video')
    },
    {
        path: '/ui/general',
        name: 'General',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/general')
    },
    {
        path: '/ui/colors',
        name: 'Colors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/ui/colors')
    },
    {
        path: '/payment/options',
        name: 'PaymentOptions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/payment_options')
    },
    {
        path: '/payment/transfers',
        name: 'MoneyTransfers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/money_transfers')
    },
    {
        path: '/paymentOptions/statement/:id',
        name: 'ModeStatement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/mode_statement')
    },
    {
        path: '/customers',
        name: 'Customers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customers')
    },
    {
        path: '/customer/deposits',
        name: 'CustomerDeposit',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_deposit')
    },
    {
        path: '/customerdeposit_details/:id',
        name: 'CustomerDeposit Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/deposit_details')
    },
    {
        path: '/customer/balances',
        name: 'Customer Balances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_balance')
    },
    {
        path: '/customer/balance_details/:id',
        name: 'Customer Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_details')
    },
    {
        path: '/customer/descriptive_balancedetails/:id',
        name: 'Descriptive Customer Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/descriptive_balancedetails')
    },
    {
        path: '/customer/print_descriptive_balancedetails/:id',
        name: 'Print Descriptive Customer Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/descriptive_balance_detailsprint')
    },
    {
        path: '/customer/print_balance_details/:id/:datefrom/:dateto',
        name: 'Print Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/balance_detailsprint')
    },
    {
        path: '/customer/customer_profile/:id',
        name: 'Customer History',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customer_profile')
    },
    {
        path: '/customer/deposit_refund',
        name: 'CustomerDeposit Refund',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/customerdeposit_refund')
    },
    {
        path: '/refund_details/:id',
        name: 'CustomerDeposit Refund Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/deposit_refund_details')
    },
    {
        path: '/customer_locations',
        name: 'Customer Locations',
        meta: { authRequired: true, setting: 'record_customerlocations', permission: 'record_customerlocations' },
        component: () =>
            import ('./views/customers/customer_locations')
    },
    {
        path: '/expenses/categories',
        name: 'ExpenseCategories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/categories')
    },
    {
        path: '/expenses/view',
        name: 'Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expenses')
    },
    {
        path: '/expenses/record',
        name: 'Expense Cart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expense_cart')
    },
    {
        path: '/expenses/creditors',
        name: 'Expense Creditors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/creditors')
    },
    {
        path: '/expenses_report',
        name: 'Expense Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expenses_report')
    },
    {
        path: '/expenses/agentexpenses',
        name: 'Agent Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/agentexpenses')
    },
    {
        path: '/expense_details/:id',
        name: 'Expenses Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/expenses/expense_details')
    },
    {
        path: '/settings/general',
        name: 'General Settings',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/general_settings')
    },
    {
        path: '/settings/receipt',
        name: 'Receipt Settings',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/receipt_settings')
    },

    // Advanced Reports
    {
        path: '/advanced_reports/debtors_report',
        name: 'Debtors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/debtors_report')
    },
    {
        path: '/advanced_reports/creditors_report',
        name: 'Creditors Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/creditors_report')
    },
    {
        path: '/advanced_reports/expenses_report',
        name: 'Expenses Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/expenses_report')
    },
    {
        path: '/advanced_reports/held_sales_report',
        name: 'Held Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/held_sales_report')
    },
    {
        path: '/advanced_reports/sales_report',
        name: 'Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sales_report')
    },
    {
        path: '/advanced_reports/shop_purchases_report',
        name: 'Shop Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/shop_purchases_report')
    },
    {
        path: '/advanced_reports/store_purchases_report',
        name: 'Store Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/store_purchases_report')
    },
    {
        path: '/advanced_reports/stocktransfers_report',
        name: 'Stock Transfers Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/stocktransfers_report')
    },
    {
        path: '/advanced_reports/internalstock_transfer',
        name: 'InternalStock Transfers Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/internalstock_transfer')
    },
    {
        path: '/stock/intransfer',
        name: 'Internal Stock Transfer',
        meta: { authRequired: true },
        component: () =>
            import ('./views/stock/intransfer_stock')
    },
    {
        path: '/advanced_reports/purchase_payments',
        name: 'Purchase payments Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchase_payments')
    },
    {
        path: '/advanced_reports/product_demand',
        name: 'Product demand Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/product_demand')
    },
    {
        path: '/advanced_reports/transactions_report',
        name: 'Transactions Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/transactions_report')
    },
    {
        path: '/advanced_reports/profitanalysis_report',
        name: 'Profit Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/profitanalysis_report')
    },
    {
        path: '/advanced_reports/salesanalysis_report',
        name: 'Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salesanalysis_report')
    },
    {
        path: '/advanced_reports/users_sales',
        name: 'User Sales Summary',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/user_sales_summary')
    },
    {
        path: '/advanced_reports/consumption',
        name: 'Product Consumption',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/product_consumption_report')
    },
    {
        path: '/advanced_reports/purchasereturns_report',
        name: 'Purchase Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/purchasereturns_report')
    },
    {
        path: '/advanced_reports/salereturns_report',
        name: 'Sale Returns Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salereturns_report')
    },
    {
        path: '/salereturn_details/:id',
        name: 'Sale Return Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/salereturn_details')
    },
    {
        path: '/advanced_reports/advancedsales_report',
        name: 'Advanced Sales Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/advancedsales_report')
    },
    {
        path: '/advanced_reports/sales_balance',
        name: 'Sales Balance Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/sales_balance')
    },
    {
        path: '/advanced_reports/monthlysales_report',
        name: 'Monthly Sales Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_report')
    },
    {
        path: '/advanced_reports/monthlysales_details/:date/:period',
        name: 'Monthly Sales Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlysales_details')
    },
    {
        path: '/advanced_reports/monthlyprofits_report',
        name: 'Monthly Profits Analysis Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_report')
    },
    {
        path: '/advanced_reports/monthlyprofits_details/:date/:period',
        name: 'Monthly Profits Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/monthlyprofits_details')
    },
    {
        path: '/users/permissions',
        name: 'Permissions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/permissions')
    },
    {
        path: '/users/access_time',
        name: 'Accesstime',
        meta: { authRequired: true },
        component: () =>
            import ('./views/users/access_time')
    },
    // Consumables
    {
        path: '/consumables/currentstock',
        name: 'Consumables Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/currentstock')
    },
    {
        path: '/consumables/add_item',
        name: 'Add Consumable Items',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/add_item')
    },
    {
        path: '/consumables/item_units',
        name: 'Consumable Item Units',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/item_units')
    },
    {
        path: '/consumables/stocking',
        name: 'Stock Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/stocking')
    },
    {
        path: '/consumables/usage',
        name: 'Use Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/usage')
    },
    {
        path: '/consumables/stocking_report',
        name: 'Input Purchases Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/stocking_report')
    },
    {
        path: '/consumables/usage_report',
        name: 'Consumables Usage Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/usage_report')
    },
    {
        path: '/consumables/creditors',
        name: 'Consumables Credtors',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/creditors')
    },
    {
        path: '/consumables/setingredients',
        name: 'Set Ingredients',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/set_ingredients')
    },
    {
        path: '/consumables/ingredients',
        name: 'Ingredients',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/ingredients')
    },
    {
        path: '/output',
        name: 'Output',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/output')
    },
    {
        path: '/consumables/spoilt',
        name: 'Spoilt Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/spoilt_stock')
    },
    {
        path: '/consumables/pendingspoilt',
        name: 'Pending SpoiltConsumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/pending_spoiltstock')
    },
    {
        path: '/consumables/rejectedspoilt',
        name: 'Rejected SpoiltConsumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/rejected_spoiltstock')
    },
    {
        path: '/consumables/reconcile',
        name: 'Reconcile Consumables',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/reconcile')
    },

    {
        path: '/consumables/movement/:id',
        name: 'Consumables Stock Movement',
        meta: {
            authRequired: true
        },
        component: () =>
            import ('./views/consumables/movements')
    },
    {
        path: '/comsumable_usage_details/:id',
        name: 'Consumable Usage Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/consumables/usage_details')
    },

    // production
    {
        path: '/production/cart',
        name: 'Production Cart',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/production_cart')
    },
    {
        path: '/production/batches',
        name: 'Production Batches',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/batches')
    },
    {
        path: '/production/batch_details/:id',
        name: 'Production Batch Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/batch_details')
    },
    {
        path: '/production/factories',
        name: 'Production Factories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/factories')
    },
    {
        path: '/factory_performance',
        name: 'Factory Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/factory_performance')
    },
    {
        path: '/output_products',
        name: 'Output Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/output_products')
    },

    // Vehicles
    {
        path: '/vehicles',
        name: 'Vehicles',
        meta: { authRequired: true },
        component: () =>
            import ('./views/vehicles/vehicles')
    },
    {
        path: '/vehicle/expenses',
        name: 'Vehicle Expenses',
        meta: { authRequired: true },
        component: () =>
            import ('./views/vehicles/vehicle_expenses')
    },
    {
        path: '/vehicle/deliveries',
        name: 'Vehicle Deliveries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/vehicles/vehicle_deliveries')
    },
    {
        path: '/vehicle/deliveries/report',
        name: 'Vehicle Deliveries Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/vehicles/vehicle_deliveries_report')
    },
    {
        path: '/vehicle/expenses/report',
        name: 'Vehicle Expenses Report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/vehicles/vehicle_expenses_report')
    },
    // Financial Statements
    {
        path: '/coa_accounts',
        name: 'COA Accounts',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/newaccount')
    },
    {
        path: '/trial_balance',
        name: 'Trial Balance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/trialbalance')
    },
    {
        path: '/income_statement',
        name: 'Income Statement',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/income_statement')
    },
    {
        path: '/transaction_details/:id',
        name: 'Transaction Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/transaction_details')
    },
    {
        path: '/balance_sheet',
        name: 'Balance Sheet',
        meta: { authRequired: true },
        component: () =>
            import ('./views/coa/balance_sheet')
    },

    // Visualisation centre
    {
        path: '/user_performance',
        name: 'User Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/userperformance')
    },

    {
        path: '/product_performance',
        name: 'Product Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/productperformance')
    },

    {
        path: '/tabular_userperformance',
        name: 'Tabular User Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/tabular_userperformance')
    },

    {
        path: '/tabular_productperformance',
        name: 'Tabular Product Performance',
        meta: { authRequired: true },
        component: () =>
            import ('./views/advanced_reports/tabular_productperformance')
    },

    // Staff Payroll
    {
        path: '/staff',
        name: 'Staff',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staff')
    },
    {
        path: '/staff_positions',
        name: 'Staff Positions',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staffpositions')
    },
    {
        path: '/staff_payroll',
        name: 'Staff Payroll',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staffpayroll')
    },
    {
        path: '/staff_advances',
        name: 'Staff Advances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staffadvances')
    },
    {
        path: '/staff_salaries',
        name: 'Staff Salaries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staffsalaries')
    },
    {
        path: '/staff_allowances',
        name: 'Staff Allowances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/staffallowances')
    },
    {
        path: '/monthly_staff_salaries',
        name: 'Monthly Staff Salaries',
        meta: { authRequired: true },
        component: () =>
            import ('./views/staff/monthly_staffsalaries')
    },

    // Agent Section
    {
        path: '/agent_collections',
        name: 'Agents Collections',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/agent_collections')
    },
    {
        path: '/agent_balances',
        name: 'Agents Balances',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/agent_balances')
    },
    {
        path: '/agent_balancedetails/:id',
        name: 'Agents Balance Details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agentaccounts/balance_details')
    },


    // Agent Stock
    {
        path: '/agent_stock/stock',
        name: 'Agents stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stock')
    },
    {
        path: '/agent_stock/stockvalue',
        name: 'Agents stock value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stockvalue')
    },
    {
        path: '/agent_stock/disburse',
        name: 'Disburse',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/disburse')
    },
    {
        path: '/agent_stock/disbursements',
        name: 'Disbursements',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/disbursements')
    },
    {
        path: '/agent_stock/reconcile_stock',
        name: 'Reconcile stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcile_stock')
    },
    {
        path: '/agent_stock/reconcilation_report',
        name: 'Reconcilation report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcilation_report')
    },
    {
        path: '/agent_stock/reconcile_details/:id',
        name: 'Reconcilation details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/reconcile_details')
    },
    {
        path: '/agent_stock/damages',
        name: 'Damages',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/damages')
    },
    {
        path: '/agent_stock/return_stock',
        name: 'Return Stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/return_stock')
    },
    {
        path: '/agent_stock/stock_returns',
        name: 'Agent stock returns',
        meta: { authRequired: true },
        component: () =>
            import ('./views/agent_stock/stock_returns')
    },
    {
        path: '/sales/agentsale',
        name: 'Agent sale',
        meta: { authRequired: true },
        component: () =>
            import ('./views/sales/agentsale')
    },
    {
        path: '/missed_customers',
        name: 'Missed Customers',
        meta: { authRequired: true },
        component: () =>
            import ('./views/customers/missed_customers')
    },
    {
        path: '/retail_outlets',
        name: 'Retail Outlets',
        meta: { authRequired: true },
        component: () =>
            import ('./views/settings/retail_outlets')
    },


    // Other routes
    {
        path: '/otherincomes',
        name: 'Other Incomes',
        meta: { authRequired: true, permission: 'view_cash_in' },
        component: () =>
            import ('./views/accounts/otherincomes')
    },
    {
        path: '/services',
        name: 'Services',
        meta: { authRequired: true, permission: 'view_services' },
        component: () =>
            import ('./views/products/services')
    },



    // Factory Stock
    {
        path: '/factory_stock/stock',
        name: 'Factories stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/stock')
    },
    {
        path: '/factory_stock/stockvalue',
        name: 'Factories stock value',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/stockvalue')
    },
    {
        path: '/factory_stock_taking',
        name: 'Reconcile Factory stock',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/reconcile_stock')
    },
    {
        path: '/factory_stock/reconcilation_report',
        name: 'Factories Stock Reconcilation report',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/reconcilation_report')
    },
    {
        path: '/factory_stock/reconcile_details/:id',
        name: 'Factories Stock Reconcilation details',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/reconcile_details')
    },
    {
        path: '/factory_stock/stock_movements/:product/:factory',
        name: 'Factory stock movements',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/movements')
    },
    {
        path: '/factory_stock/production_batches',
        name: 'Factories Production Batches',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/factories_batches')
    },
    {
        path: '/factory_stock/batch_stock_movements/:batch',
        name: 'Batch stock movements',
        meta: { authRequired: true },
        component: () =>
            import ('./views/factory_stock/batch_stock_movements')
    },

    // Production with use of ingredients
    {
        path: '/set_bill_of_materials',
        name: 'Set Bill of Materials',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/set_bill_of_materials')
    },
    {
        path: '/view_bill_of_materials',
        name: 'View Bill of Materials',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/bill_of_materials')
    },
    {
        path: '/use_raw_materials',
        name: 'Use Raw Materials',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/use_raw_materials')
    },
    {
        path: '/report_finished',
        name: 'Report Finished',
        meta: { authRequired: true },
        component: () =>
            import ('./views/production/report_finished')
    },

    // Market Place
    {
        path: '/marketplace/add_item',
        name: 'Add Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/marketplace/add_product')
    },    
    {
        path: '/marketplace/view_items',
        name: 'View Products',
        meta: { authRequired: true },
        component: () =>
            import ('./views/marketplace/products')
    },
    {
        path: '/marketplace/categories',
        name: 'Product Categories',
        meta: { authRequired: true },
        component: () =>
            import ('./views/marketplace/categories')
    },
]